import AuthenticationPage from '../components/layout/AuthenticationPage.vue';
import HomePage from '../components/layout/HomePage.vue';
import ChartsPage from '../components/layout/ChartsPage.vue';

const routes = [
    {
        path: '/auth',
        component: AuthenticationPage,
    },
    {
        path: '/',
        component: HomePage,
        children: [
            {
                path: '',
                component: ChartsPage,
            },
        ],
    },
];

export default routes;
